import i18next from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import enTranslation from "../locales/en/translation.json";

// This deployment is Finnish-only. The "en" locale file carries the Finnish
// strings (the upstream fallback locale is overwritten by the overlay), and
// the other upstream locales are not registered: with browser language
// detection active, a browser set to e.g. Italian or Spanish would otherwise
// pick that locale's stock strings instead of the Finnish ones. i18next is
// pinned to "en" so detection never runs at all.
//
// The locale is fi-FI so that the speech input/output components ask the
// browser for Finnish speech recognition and synthesis.
export const supportedLngs: { [key: string]: { name: string; locale: string } } = {
    en: {
        name: "Suomi",
        locale: "fi-FI"
    }
};

i18next
    .use(HttpApi)
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        resources: {
            en: { translation: enTranslation }
        },
        lng: "en",
        fallbackLng: "en",
        supportedLngs: Object.keys(supportedLngs),
        debug: import.meta.env.DEV,
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        }
    });

export default i18next;
